import React, { useState, useEffect } from "react";
import ProjectHeader from "./ProjectHeader";
import ProjectContainer from "./ProjectContainer";
import FormContainer from "./Form/FormContainer";
import { profileOrganization, getOrganization as getOrganizationApi } from "api/organizations";
import OrganizationForm from "./Form/OrganizationForm";
import { getProfileProducts, getProfileSolutions } from "api/solutions";
import { useCoordinates } from "hooks/CoordinatesContext";
import { useOrganization } from "hooks/OrganizationContext";
import ProjectTabs from "./ProjectTabs";
import ProjectMultiStepModal from "./ProjectMultiStepModal";
import GoogleMapProject from "./GoogleMapProject";
import OrganizationWizard from "./OrganizationWizard";
import { connectionProfile, ConnectionProfile } from "@/lib/constants";

type Project = {
  id: string;
  name: string;
  desc: string;
  location: string;
  coordinates: [number, number] | null; // Nullable array of two numbers
  title: string;
  type: string; // Literal type
  bgColor: string;
  icon: string;
  status: string;
  link: string;
  isEditable: boolean;
};

const operationalExcelenceData = [
  {
    title: "EnergyHub",
    type: "FREE TRIAL",
    bgColor: "bg-[#2b5f8a]",
    icon: "/images/cpu.svg",
    status: "Public Project",
    link: "https://energyhub.processhub.ai/",
    desc: null,
    isEditable: false,
    isPrivate: false
  },
  {
    title: "Leap24",
    type: "FREE TRIAL",
    bgColor: "bg-[#2b5f8a]",
    icon: "/images/cpu.svg",
    status: "Public Project",
    link: "https://leap24.processhub.ai/",
    desc: null,
    isEditable: false,
    isPrivate: false
  },
  {
    title: "Data Center",
    type: "FREE TRIAL",
    bgColor: "bg-[#2b5f8a]",
    icon: "/images/cpu.svg",
    status: "Public Project",
    link: "https://datacenter.processhub.ai/",
    desc: null,
    isEditable: false,
    isPrivate: false
  },
  {
    title: "Water Tower",
    type: "FREE TRIAL",
    bgColor: "bg-[#2b5f8a]",
    icon: "/images/cpu.svg",
    status: "Public Project",
    link: "https://culturalhub.processhub.ai/",
    desc: null,
    isEditable: false,
    isPrivate: false
  },
  {
    title: "Car Simulator",
    type: "FREE TRIAL",
    bgColor: "bg-[#2b5f8a]",
    icon: "/images/cpu.svg",
    status: "Public Project",
    link: "https://car.processhub.ai/",
    desc: null,
    isEditable: false,
    isPrivate: false
  },
  {
    title: "EXPO2030",
    type: "FREE TRIAL",
    bgColor: "bg-[#2b5f8a]",
    icon: "/images/cpu.svg",
    status: "Public Project",
    link: "https://expo2030.processhub.ai/",
    desc: null,
    isEditable: false,
    isPrivate: false,
    createdAt: "2025-12-12"
  }
  // {
  //   title: "Energy Solution",
  //   type: "FREE TRIAL",
  //   bgColor: "bg-gradient-to-b from-green to-blue",
  //   icon: "/images/cpu.svg",
  //   status: "Public Project",
  //   link: "https://product.processhub.ai/o/0ed25137-caf2-42a0-bac0-4cd3e6b1bc8f/s/8ff5a48c-63ad-494b-a444-6e1173cf785c",
  //   desc: "Energy",
  //   isEditable: false,
  //   isPrivate: false 
  // }
  // {
  //   title: "SAAS",
  //   type: "FREE TRIAL",
  //   bgColor: "bg-gradient-to-b from-green to-blue",
  //   icon: "/images/cpu.svg",
  //   status: "Public Project",
  //   link: "https://product.processhub.ai/",
  //   isEditable: false
  // },
];

const progressMonitoringData = [
  {
    title: "DEMO PROJECT",
    type: "FREE TRIAL",
    category: "Progress Monitoring",
    bgColor: "bg-[#8A8A8A]",
    icon: "/images/cpu.svg",
    status: "Private Project",
    link: '',
    isEditable: false,
    isPrivate: true
  },
  {
    title: "DEMO PROJECT",
    type: "FREE TRIAL",
    category: "Progress Monitoring",
    bgColor: "bg-[#8A8A8A]",
    icon: "/images/cpu.svg",
    status: "Private Project",
    link: '',
    isEditable: false,
    isPrivate: false
  },
  {
    title: "DEMO PROJECT",
    type: "FREE TRIAL",
    category: "Progress Monitoring",
    bgColor: "bg-[#8A8A8A]",
    icon: "/images/cpu.svg",
    status: "Private Project",
    link: '',
    isEditable: false,
    isPrivate: false
  },
];

const initProject = {
  id: "",
  name: "",
  desc: "",
  location: "",
  coordinates: null,
  title: "",
  type: "PROJECT",
  industry: "",
  projectType: "",
  isPublic: true,
  bgColor: "",
  icon: "",
  status: "",
  link: "",
  isEditable: false,
};

interface ProjectHomeProps {
  setRefreshMode: React.Dispatch<React.SetStateAction<string>>;
  refreshMode: string;
}

const ProjectHome: React.FC<ProjectHomeProps> = ({ setRefreshMode, refreshMode }) => {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const { selectedOrganization, setSelectedOrganization } = useOrganization();
  const [selectedProject, setSelectedProject] = useState<Project>(initProject);
  console.log("selectedProject", selectedProject);
  const [organizations, setOrganizations] = useState([]);
  const [windowMode, setWindowMode] = useState<'projects' | 'newProject' | 'editProject' | 'newOrganization' | 'editOrganization'>('projects');
  const [newProjectModal, setNewProjectModal] = useState(false);
  const [allProjects, setAllProjects] = useState<any>([]);
  const [progressProjects, setProgressProjects] = useState<any>([]);
  const [activeTab, setActiveTab] = useState('operational');
  const { setCoordinates } = useCoordinates();
  const [orgFormState, setOrgFormState] = useState({ id: '', name: '', desc: '' });
  const [profileProducts, setProfileProducts] = useState<any>([]);
  const [markersLoaded, setMarkersLoaded] = useState(false);
  const [userProjects, setUserProjects] = useState<any>([]);
  const [projectFormState, setProjectFormState] = useState({
    projectName: "",
    productLocation: "",
    building: "",
    description: "",
    isPublic: true,
    industry : "",
    projectType: "", 
    coordinates: [null, null] as [number | null, number | null],
  });
  const [projectMode, setProjectMode] = useState<'create' | 'edit'>('create');
  const [step, setStep] = useState(1);
  const [orgStep, setOrgStep] = useState(1);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [isOrganizationWizardOpen, setIsOrganizationWizardOpen] = useState(false);
  const [organizationWizardMode, setOrganizationWizardMode] = useState<'create' | 'edit'>('create');
  const [selectedAsset, setSelectedAsset] = useState<string | null>(null);
  const [connectionProfiles, setConnectionProfiles] = useState<ConnectionProfile[]>(connectionProfile);
  const [isAgreementChecked, setIsAgreementChecked] = useState<boolean>(false);
  const [uploadBoxFilePreview, setUploadBoxFilePreview] = useState<string>("");
  const [isUnityExists, setIsUnityExists] = useState(false);
  const [showUploadZone, setShowUploadZone] = useState<boolean>(false);
  const handleAddNewOrganization = () => {
    setOrgFormState({ id: '', name: '', desc: '' });
    // setWindowMode('newOrganization');
    setIsOrganizationWizardOpen(true);
    setOrganizationWizardMode('create');
    setOrgFormState({ id: '', name: '', desc: '' });
  };

  const handleAddNewProject = () => {
    setCoordinates([0, 0]);
    setSelectedProject(initProject);
    setNewProjectModal(true);
    setProjectMode('create');
    setStep(1);
    setSelectedOption(null);
    setSelectedAsset(null);
    setIsAgreementChecked(false);
    setUploadBoxFilePreview("");
    setShowUploadZone(false);
    setProjectFormState({
      projectName: "",
      productLocation: "",
      building: "",
      description: "",
      isPublic: true,
      industry : "",
      projectType: "", 
      coordinates: [null, null] as [number | null, number | null],
    });
  };

  const checkUnityExists = () => {

    const userAgent = navigator.userAgent;
    // const userAgent = "Safar - google / mozilla /Unity";
    setIsUnityExists(userAgent.includes("Unity"));

  };

  useEffect(() => {
    if (!isUnityExists) {
      checkUnityExists();
    }
  }, [isUnityExists]);


  // Function to get Operational Excellence projects (currently using the main API)
  const getOperationalProjects = async (id: string) => {
    const response = await getProfileSolutions(id);
    if (response.status === 200) {
      const newProjects = response.data.list.map((item: any) => {
        return {
          ...item,
          title: item.name,
          type: "PROJECT",
          bgColor: "bg-gradient-to-b from-green to-blue",
          icon: "/images/cpu.svg",
          status: "Private Project",
          link: item.url,
          isEditable: true
        };
      });

      selectedOrganization.id === '0ed25137-caf2-42a0-bac0-4cd3e6b1bc8f' ?
        setAllProjects([...operationalExcelenceData, ...newProjects]) :
        setAllProjects(newProjects);

      setIsLoading(false);
    }
    else {
      setError(response.data);
    }
  };

  // Function to get Progress Monitoring projects
  // Currently using the same API as Operational Excellence, but can be changed in the future
  const getProgressProjects = async (id: string) => {
    const response = await getProfileSolutions(id);
    if (response.status === 200) {
      const newProjects = response.data.list.map((item: any) => {
        return {
          ...item,
          title: item.name,
          type: "PROJECT",
          bgColor: "bg-gradient-to-b from-green to-blue",
          icon: "/images/cpu.svg",
          status: "Private Project",
          link: item.url,
          isEditable: true
        };
      });

      setProgressProjects(newProjects);
    }
    else {
      setError(response.data);
    }
  };

  // Main function to fetch all projects based on the active tab
  const getAllProjects = async (id: string) => {

    try {
      setIsLoading(true);

      // Get Operational Excellence projects
      await getOperationalProjects(id);

      // Get Progress Monitoring projects
      await getProgressProjects(id);

      setIsLoading(false);

      const response = await getProfileSolutions(id);
      if (response.status === 200) {
        const newProjects = response.data.list
          .map((item: any) => ({
            ...item,
            title: item.name,
            type: "PROJECT",
            bgColor: "bg-gradient-to-b from-green to-blue",
            icon: "/images/location-pin.png",
            status: "Private Project",
            link: item.url,
            isEditable: true,
            coordinates: item.coordinates ? JSON.parse(item.coordinates) : null
          }))
          .filter((project: any) => project.coordinates !== null);

        setUserProjects(newProjects);
      }
    } catch (error) {
      console.error("Error loading projects:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setMarkersLoaded(true);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    getAllProjects(selectedOrganization.id);
    fetchProfileProducts(selectedOrganization.id);
    setWindowMode('projects');
  }, [selectedOrganization]);

  useEffect(() => {
    if (organizations.length > 0) {
      setSelectedOrganization(organizations[0]);
      setIsLoading(false);
    }
  }, [organizations]);

  const setOrganizationsList = async () => {
    const response = await profileOrganization();
    if (response.status === 200) {
      setOrganizations(response.data.list);
    }
    else {
      setError(response.data);
    }
  };

  const getOrganization = async () => {
    const response = await getOrganizationApi(selectedOrganization.id);
    if (response.status === 200) {
      setOrgFormState(response.data.data);
    }
    else {
      setError(response.data);
    }
  };
  const fetchProfileProducts = async (id: string) => {
    const response = await getProfileProducts(id);
    if (response.status === 200) {
      // Sort the products to ensure Operational Excellence is always first
      const sortedProducts = response.data.list.sort((a: any, b: any) => {
        if (a.name === "Operational Excellence") return -1;
        if (b.name === "Operational Excellence") return 1;
        if (a.name === "Progress Monitoring") return -1;
        if (b.name === "Progress Monitoring") return 1;
        return 0;
      });
      
      setProfileProducts(sortedProducts);
      console.log("profileProductssssssss", sortedProducts);
      if (isUnityExists) {
        setActiveTab(sortedProducts[1].id);
      } else {
        setActiveTab(sortedProducts[0].id);
      }
    }
    else {
      setError(response.data);
    }
  };


  const handleOrgEdit = () => {
    getOrganization();
    // setWindowMode('editOrganization');
    setIsOrganizationWizardOpen(true);
    setOrganizationWizardMode('edit');
  };

  const handleOrganizationWizardClose = () => {
    setIsOrganizationWizardOpen(false);
  };

  useEffect(() => {
    setOrganizationsList();
  }, []);

  useEffect(() => {
    if (selectedProject.id !== '') {
      // setWindowMode('editProject');
      setNewProjectModal(true);
      setProjectMode('edit');
    }
  }, [selectedProject]);

  useEffect(() => {
    if (refreshMode === 'organizations') {
      setOrganizationsList();
    }
    if (refreshMode === 'solutions') {
      getAllProjects(selectedOrganization.id);
      setSelectedProject(initProject);
      setWindowMode('projects');
    }
    setRefreshMode('');
  }, [refreshMode]);


  useEffect(() => {
    fetchProfileProducts(selectedOrganization.id);
  }, []);

  useEffect(() => {
    console.log("profileProducts", profileProducts);
  }, [profileProducts]);


  return (
    <section
      style={{
        position: "relative",
        backgroundImage: `url(/images/about.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "bottom",
        filter: "opacity(100%)",
      }}
      className="relative h-screen"
    >
      <div className="absolute inset-0 bg-black opacity-80 z-0"></div>
      <div className="relative z-10 pt-4">
        <ProjectHeader
          organizations={organizations}
          handleAddNew={handleAddNewOrganization}
          handleOrgEdit={handleOrgEdit}
          isLoading={isLoading}
        />


        <div className="flex gap-5 container mt-5 h-[calc(100vh-200px)]">
          <div className="bg-[#1A1A1A] rounded-xl p-6 border border-white/[0.08] w-[50%] h-full">
            {/* {windowMode === 'newProject' &&
              <div className="container pt-2 pb-4">
                <FormContainer title="CREATE PROJECT" setWindowMode={setWindowMode}>
                  <NewProjectForm setRefreshMode={setRefreshMode} setError={setError} mode="create" formState={projectFormState} setFormState={setProjectFormState} setIsLoading={setIsLoading} selectedOrganization={selectedOrganization} selectedProject={selectedProject} />
                </FormContainer>
              </div>
            }

            {windowMode === 'editProject' &&
              <div className="container pt-2 pb-4">
                <FormContainer title="EDIT PROJECT" setWindowMode={setWindowMode}>
                  <NewProjectForm setRefreshMode={setRefreshMode} setError={setError} mode="edit" formState={projectFormState} setFormState={setProjectFormState} setIsLoading={setIsLoading} selectedOrganization={selectedOrganization} selectedProject={selectedProject} />
                </FormContainer>
              </div>
            } */}

            {/* {windowMode === 'newOrganization' &&
              <div className="p-2">
                <FormContainer title="CREATE ORGANIZATION" setWindowMode={setWindowMode}>
                  <OrganizationForm handleOrganizationWizardClose={handleOrganizationWizardClose} setRefreshMode={setRefreshMode} setError={setError} mode="create" formState={orgFormState} setFormState={setOrgFormState} setIsLoading={setIsLoading} />
                </FormContainer>
              </div>
            }

            {windowMode === 'editOrganization' &&
              <div className="p-2">
                <FormContainer title="EDIT ORGANIZATION" setWindowMode={setWindowMode}>
                  <OrganizationForm handleOrganizationWizardClose={handleOrganizationWizardClose} setRefreshMode={setRefreshMode} setError={setError} mode="edit" formState={orgFormState} setFormState={setOrgFormState} setIsLoading={setIsLoading} />
                </FormContainer>
              </div>
            } */}

            {windowMode === 'projects' && <ProjectTabs
              activeTab={activeTab}
              onTabChange={setActiveTab}
              profileProducts={profileProducts}
              isUnityExists={isUnityExists}
            >
              {profileProducts.length > 0 ? profileProducts.map((product: any) => {

                return (
                  <div key={product.id} className="mt-4">
                    {activeTab === product.id && (
                      <ProjectContainer
                        activeTab={activeTab}
                        title={product.name}
                        data={product?.name.includes('Operational Excellence') ? allProjects : progressProjects}
                        handleAddNew={handleAddNewProject}
                        isDisabled={false}
                        isLoading={isLoading}
                        setSelectedProject={setSelectedProject}
                        productId={product.id}
                      />
                    )}
                  </div>
                );
              }
              ) : (
                <div className="flex justify-center items-center h-full">
                  <div className="text-white text-2xl font-bold">No projects found</div>
                </div>
              )}
            </ProjectTabs>}
          </div>
          <div className="bg-[#1A1A1A] rounded-xl p-6 border border-white/[0.08] w-[50%] h-full flex-1 overflow-hidden">
            <GoogleMapProject    activeTab={activeTab} userProjects={userProjects} markersLoaded={markersLoaded} height={"100%"} />
          </div>
        </div>
      </div>

      <ProjectMultiStepModal
        from={"projectsHome"}
        step={step}
        setStep={setStep}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        isLoading={isLoading}
        setNewProjectModal={setNewProjectModal}
        isOpen={newProjectModal}
        onClose={() => setNewProjectModal(false)}
        setRefreshMode={setRefreshMode}
        setError={setError}
        mode={projectMode}
        formState={projectFormState}
        setFormState={setProjectFormState}
        setIsLoading={setIsLoading}
        selectedOrganization={selectedOrganization}
        selectedProject={selectedProject}
        activeTab={activeTab}
        selectedAsset={selectedAsset}
        setSelectedAsset={setSelectedAsset}
        connectionProfiles={connectionProfiles}
        setConnectionProfiles={setConnectionProfiles}
        isAgreementChecked={isAgreementChecked}
        setIsAgreementChecked={setIsAgreementChecked}
        uploadBoxFilePreview={uploadBoxFilePreview}
        setUploadBoxFilePreview={setUploadBoxFilePreview}
        setShowUploadZone={setShowUploadZone}
        showUploadZone={showUploadZone}
      />
      <OrganizationWizard orgStep={orgStep} setOrgStep={setOrgStep} isLoading={isLoading} setRefreshMode={setRefreshMode} setError={setError} orgFormState={orgFormState} setOrgFormState={setOrgFormState} setIsLoading={setIsLoading} mode={organizationWizardMode} isOrganizationWizardOpen={isOrganizationWizardOpen} handleOrganizationWizardClose={handleOrganizationWizardClose} />
    </section>
  );
};

export default ProjectHome;